<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Clients"
                createIconText="Ajouter un client"
                importDatasourceName="customers"
                (created)="onCustomerCreated()"
                (exported)="onCustomersExported()"
                (imported)="onCustomersImported()"
                (helped)="onCustomersHelped()"></app-list-header>
        </mat-expansion-panel-header>
        <app-customers-list
            #itemsList
            (itemSelected)="onCustomerSelected($event)"
            (itemDisplayed)="onCustomerDisplayed($event)"
            (itemEdited)="onCustomerEdited($event)"
            (itemDeleted)="onCustomerDeleted($event)"
            (itemDuplicated)="onCustomerDuplicated($event)"></app-customers-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onCustomerDisplayed(context?.formContext.item)"
                    (edited)="onCustomerEdited(context?.formContext.item)"
                    (helped)="onCustomersHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-customer-detail [context]="context" (customerUpdated)="customerUpdated($event)" (canceled)="onBackToList()"></app-customer-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
